const PREFIX = 'WISHLIST_';

export const WISHLIST_ACTIONS = {
  SET_ITEMS: `${PREFIX}SET_ITEMS`,
  ADD_ITEM: `${PREFIX}ADD_ITEM`,
  DELETE_ITEM: `${PREFIX}DELETE_ITEM`,
  SET_PREVENT_SNACKBAR: `${PREFIX}SET_PREVENT_SNACKBAR`,
  SET_PREVENT_WISHLIST_CHUNK_TO_LOAD: `${PREFIX}SET_PREVENT_WISHLIST_CHUNK_TO_LOAD`,
  SET_WISHLIST_FETCHING_STATUS: `${PREFIX}SET_WISHLIST_FETCHING_STATUS`,
};

export const wishlistReducer = (state, action) => {
  switch (action.type) {
    case WISHLIST_ACTIONS.SET_ITEMS:
      return {
        ...state,
        items: action.items,
      };
    case WISHLIST_ACTIONS.ADD_ITEM:
      return {
        ...state,
        items: [...state.items, action.item],
        lastAction: 'ADDED',
      };
    case WISHLIST_ACTIONS.DELETE_ITEM:
      return {
        ...state,
        items: state.items.filter(
          el => el.originalId !== action.item.originalId,
        ),
        lastAction: 'DELETED',
      };
    case WISHLIST_ACTIONS.SET_PREVENT_SNACKBAR:
      return {
        ...state,
        preventSnackbar: action.status,
      };
    case WISHLIST_ACTIONS.SET_PREVENT_WISHLIST_CHUNK_TO_LOAD:
      return {
        ...state,
        preventWishlistChunkToLoad: action.status,
      };
    case WISHLIST_ACTIONS.SET_WISHLIST_FETCHING_STATUS:
      return {
        ...state,
        fetchingStatus: action.status,
      };

    default:
      return state;
  }
};
